import { render, staticRenderFns } from "./index.vue?vue&type=template&id=436df57e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436df57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436df57e')) {
      api.createRecord('436df57e', component.options)
    } else {
      api.reload('436df57e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=436df57e&scoped=true", function () {
      api.rerender('436df57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/material/index.vue"
export default component.exports